import { render, staticRenderFns } from "./RatingDistribution.vue?vue&type=template&id=34c72220&scoped=true&"
import script from "./RatingDistribution.vue?vue&type=script&lang=js&"
export * from "./RatingDistribution.vue?vue&type=script&lang=js&"
import style0 from "./RatingDistribution.vue?vue&type=style&index=0&id=34c72220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c72220",
  null
  
)

export default component.exports